import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { addEventListener } from '@ifeng-fe/ui_base';
import styles from './index.css';

class ScrollDisplay extends PureComponent {
    static propTypes = {
        children: PropTypes.element,
    };

    unlistenerHandleWindowScroll = null; // 事件解绑
    state = {
        isDisplay: true, // 判断返回顶部的按钮是否显示
    };

    componentDidMount() {
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if (scroll >= 2200) {
            this.setState({ isDisplay: false });
        }

        this.unlistenerHandleWindowScroll = addEventListener(window, 'scroll', this.handleWindowScroll);
    }
    componentWillUnmount() {
        this.unlistenerHandleWindowScroll();
    }
    // 判断返回顶部按钮的显示隐藏
    handleWindowScroll = event => {
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const isDisplay = scroll < 1500;

        if (isDisplay !== this.state.isDisplay) {
            this.setState({ isDisplay });
        }
    };
    viewRender() {
        return ReactDOM.createPortal(<div className={styles.box}>{this.props.children}</div>, document.body);
    }
    render() {
        const { isDisplay } = this.state;

        if (typeof document === 'object') {
            return isDisplay ? this.viewRender() : null;
        } else {
            return null;
        }
    }
}

export default ScrollDisplay;
